const config = {
  serverUrl: "https://formserver.rapidmail.pro",
  untitledFormName: "Untitled form",
  type_options: ["Short Answer", "Long Answer", "Dropdown", "MCQ"],
  quetionTypesWithOptions: [2, 3],
  severOfflineMsg: "Server is offline.",
};

module.exports = config;
